const initialState = {
  contractors: [],
  locations: [],
  companies: [],
  jobs: [],
  typeCodes: [],
  selectedRows: [],
  initialFetchIsDone: false,
  loading: true,
  perPage: 20,
  page: 0,
  totalItems: 0,
  qs: "",
};

export default initialState;
